export const SET_IS_ADMIN_LOGGED_IN = "setIsAdminLoggedIn";
